// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-icons[data-v-73968b0a] {\n  margin-right: 20px;\n}\n.login-button[data-v-73968b0a] {\n  min-width: unset;\n  margin: 0 !important;\n  padding: 0 !important;\n  border: none;\n  height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
